import Pochta from "./Pochta";
function INTJ()
{
     return(
        <div className="Glavn">
  <div className='catalog' >
        <div className="image">
          <div className="image-wrapper" >
      <img src="/img/INTJ Стратег.png" className="INTJ"/>
      {/* <h1>Дипломат</h1>
      <h2>ENFP</h2> */}
      </div>
       <div className="result">
         <h2>INTJ</h2>
    <p><strong>Процент населения:</strong> 2–4%</p>
<p><strong>Среди мужчин:</strong> 3–5%</p>
<p><strong>Среди женщин:</strong> менее 1%</p>
<p><strong>Стратегия:</strong> Непрерывное развитие</p>

<p><strong>Психологические особенности:</strong></p>
<p>
  INTJ черпают энергию в одиночестве и глубоких размышлениях. 
  Им нужно время, чтобы обдумать стратегию и увидеть картину целиком. 
  Они восстанавливают силы в тишине, вдали от внешнего шума.
</p>
<p>
  Решения INTJ принимают на основе логики и долгосрочного видения. 
  Они доверяют своему аналитическому уму и редко поддаются эмоциям. 
  Они ценят компетентность, эффективность и независимость.
</p>
<p>
  Это стратегические и целеустремлённые люди. 
  Они всегда видят будущее и знают, как к нему прийти. 
  Им трудно принимать некомпетентность, но их идеи меняют мир.
</p>

<p><strong>Особенность:</strong></p>
<p>
  INTJ — самые закрытые и независимые люди. Их невозможно контролировать, 
  они не ищут одобрения и не нуждаются в компании. Они живут в своей голове, 
  и посторонних туда не пускают. Их холодность и отстранённость часто пугают. 
  Они не объясняют свои решения, потому что считают это пустой тратой времени.
</p>

<p>
  INTJ — это человек, который может изменить мир, но не выйдет из комнаты, 
  если ему неинтересно. Они живут будущим настолько сильно, что настоящее 
  кажется им черновиком. Их главная магия — видеть то, что не видят другие, 
  и молчать об этом до тех пор, пока время не докажет их правоту.
</p>

  </div>
  <Pochta/>
  </div>
  </div>
   </div>
       );
}
export default INTJ;